export { ImageDisplay } from "./ImageDisplay"
export type { ImageDisplayProps } from "./ImageDisplay"
